import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import { List } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import resourceNames from "../../../common/data/resourceNames";
import { MasterEldDeviceDto } from "../../../common/data/service-proxies";

interface Props {
  record?: MasterEldDeviceDto;
}

export const ShowEldMessagesMenuItem = ({ record }: Props) => {
  const history = useHistory();
  if (!record) {
    return null;
  }

  if (!record.debuggingEnabled) {
    return null;
  }

  if (!record.serialNumber) {
    return null;
  }

  return (
    <MenuItem
      className="actions-menu-item"
      onClick={(e) => {
        history.push(
          `/${resourceNames.MASTER_ELDS}/show-messages/${record.serialNumber}`
        );
      }}
    >
      <ListItemIcon>
        <List />
      </ListItemIcon>
      <ListItemText>Show Geometris messages</ListItemText>
    </MenuItem>
  );
};
